import PageTitle from "../../comman/page-title";

const PrivacyPolicyComponent = () => {
  return (
    <>
      <PageTitle title="Privacy Policy" description="Privacy Policy" />
      <main className="bg_gray">
        <div className="container margin_60_20">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="box_general write_review">
                <div className="main_title center mb-2">
                  <span><em></em></span>
                </div>

                <h4 className="mt-3 mb-4 text-center">Privacy Policy</h4>

                {/* INTRODUCTION */}
                <p>
                  The below privacy policy (“Privacy Policy”) explains how we collect,
                  use, store, process, transfer, disclose and protect your personal
                  information you provided to us. Please read it carefully to make sure
                  you understand our privacy practices. If you do not agree with the
                  terms of this Privacy Policy, please do not access our Yalla Fel Sekka
                  Application (“Application”).
                </p>

                {/* SECTION 1 */}
                <h5 className="mt-4">1. Information We Collect</h5>

                <p>
                  You hereby acknowledge, agree and consent that we have the right to
                  collect and store your Personal Information as follows:
                </p>

                <p>
                  Yalla Fel Sekka collects information you provide directly to us, such as
                  when you create or modify your account, request on-demand services,
                  contact customer support, or otherwise communicate with or use the
                  services of Yalla Fel Sekka. Such information includes, but is not limited
                  to: name, voice, biometrics, online identifier, identification card
                  number, vehicle license number (for drivers), nationality, address,
                  telephone number, mobile number, bank account details, credit card
                  details, gender, date of birth, health and psychological status, marital
                  status, resident status, security status, education background, financial
                  background, personal interests, email address, occupation, and other
                  personally identifiable information (“Personal Data” or “Personal
                  Information”).
                </p>

                <p>
                  The provision of your Personal Data is voluntary unless otherwise stated.
                  However, if you do not provide your Personal Data, Yalla Fel Sekka will
                  not be able to process it for the purposes outlined below.
                </p>

                <p>
                  By accepting this Privacy Policy, you agree that Yalla Fel Sekka may
                  receive, collect, use, store, process and transfer your Personal Data in
                  accordance with the following terms.
                </p>

                <p>
                  If you are an agent, vendor, supplier, or service provider, the provision
                  of Personal Data is mandatory and failure to provide it may prevent us
                  from engaging you or issuing payments.
                </p>

                <p>
                  When using the Yalla Fel Sekka Services, we may collect: your
                  geo-location (whether the app is used or not), contacts (access and store
                  names and numbers in your address book), transaction details, usage and
                  preference information (cookies, pixel tags), device information
                  (hardware model, OS, device ID, IP, serial, advertising identifier), call
                  and SMS metadata (date, time, numbers, message content), server logs,
                  browser type, crash data, and third-party site information.
                </p>

                <h6>Examples include:</h6>
                <ul>
                  <li>Your location & destination when requesting a service.</li>
                  <li>Technical data such as IP address, Device ID, OS details.</li>
                  <li>
                    Contact details of a person for delivery purposes (you must obtain
                    their consent).
                  </li>
                  <li>Your referral code (we do not collect your friends’ data).</li>
                  <li>
                    Real-time GPS tracking to locate couriers and provide updates.
                  </li>
                </ul>

                <h6>Additional information we collect:</h6>
                <ul>
                  <li>
                    Phone number of a contact person for the courier (with your obligation
                    to obtain consent).
                  </li>
                  <li>
                    Referral sharing where we only prepare a message — we don’t collect
                    your friends' information.
                  </li>
                  <li>
                    Real-time geo-location tracking to show nearby couriers and improve
                    service.
                  </li>
                </ul>

                {/* SECTION 2 */}
                <h5 className="mt-5">2. Using Your Personal Information</h5>

                <p>You agree that we may use your Personal Information as follows:</p>

                <ul>
                  <li>
                    Use your email, name, phone number, and password to verify your
                    account and communicate about your orders.
                  </li>
                  <li>
                    Send you updates, special offers, promotions, or ask you to subscribe
                    to our mailing list (you can opt-out anytime).
                  </li>
                  <li>
                    Use your geo-location to find nearby Service Providers, calculate fees,
                    and analyze app usage.
                  </li>
                  <li>
                    Receive information from social login, payment providers, or apps using
                    our API.
                  </li>
                  <li>
                    Improve services, prevent fraud, personalize content, send promotions,
                    and recommend services.
                  </li>
                  <li>
                    Transfer and store your data in Egypt or any country with adequate data
                    protection.
                  </li>
                </ul>

                {/* SECTION 3 */}
                <h5 className="mt-5">3. Sharing Your Personal Information</h5>

                <p>You agree that Yalla Fel Sekka may share your information as follows:</p>

                <ul>
                  <li>
                    With Service Providers (e.g., courier) to complete your order — name,
                    phone number, destination, geo-location, and item details.
                  </li>
                  <li>
                    With your contact person's phone number for delivery purposes.
                  </li>
                  <li>
                    With Service Providers who must delete your data after service (we are
                    not responsible if they fail to do so).
                  </li>
                  <li>
                    With third-party companies performing tasks on our behalf (customer
                    support, maintenance, analytics).
                  </li>
                  <li>
                    When legally required, during disputes, regulatory requests, or health
                    and safety emergencies.
                  </li>
                  <li>
                    With partners, affiliated companies, employees, directors, agents, and
                    subcontractors on a need-to-know basis.
                  </li>
                  <li>
                    For promotions, public forums, partner services, targeted ads, or in
                    anonymized statistical form.
                  </li>
                  <li>
                    During business transactions (merger, sale, restructuring).
                  </li>
                </ul>

                {/* SECTION 4 */}
                <h5 className="mt-5">4. Cookies and Advertising</h5>

                <p>
                  A cookie is a small file that stores user preferences. Cookies help us
                  analyze traffic, improve user experience, and tailor services. We may
                  use traffic log cookies to identify usage patterns for statistical
                  analysis. You cannot decline cookies.
                </p>

                {/* SECTION 5 */}
                <h5 className="mt-5">5. Retaining Your Personal Information</h5>

                <p>
                  We will retain your Personal Information until you cancel your account in
                  the Application.
                </p>

                {/* SECTION 6 */}
                <h5 className="mt-5">6. Third-Party Websites</h5>

                <p>
                  The Application may contain links to third-party websites or services.
                  Any information you provide to third-party sites is not covered under
                  this Privacy Policy. You must review their policies. We are not
                  responsible for third-party content, practices, security, or actions.
                </p>

                {/* SECTION 7 */}
                <h5 className="mt-5">7. Database Security</h5>

                <p>
                  We do our best to secure our database; however, we cannot guarantee
                  interception-free transmission. Any data sent to us is at your own risk.
                  Do not disclose your password or Personal Data to anyone. No system is
                  100% secure.
                </p>

                {/* SECTION 8 */}
                <h5 className="mt-5">8. Changes to this Privacy Policy</h5>

                <p>
                  We may amend this Privacy Policy at any time. Modifications are effective
                  immediately upon posting. We may notify you via email or website notice
                  24 hours before changes take effect. Continued use constitutes acceptance
                  of the updated Privacy Policy.
                </p>

                {/* SECTION 9 */}
                <h5 className="mt-5">9. Notices</h5>

                <p>
                  Yalla Fel Sekka may give notice by email, app notifications, or written
                  communication to your registered address. You may send notices to:
                </p>

                <p>
                  <strong>Address:</strong> Building 57 Street 250 – Degla Maadi, Cairo, Egypt
                </p>

                {/* SECTION 10 */}
                <h5 className="mt-5">10. Limitation of Liability</h5>

                <p>
                  Yalla Fel Sekka shall not be liable for indirect, incidental, special,
                  exemplary, punitive or consequential damages, including lost profits or
                  data. Total liability will not exceed 100 Egyptian Pounds (LE 100).
                </p>

                {/* SECTION 11 */}
                <h5 className="mt-5">11. Miscellaneous</h5>

                <ul>
                  <li>
                    You may not assign this Privacy Policy. Yalla Fel Sekka may assign it to
                    subsidiaries, affiliates, acquirers, or successors.
                  </li>
                  <li>
                    No partnership, joint venture, agency or employment relationship exists
                    between you and Yalla Fel Sekka.
                  </li>
                  <li>
                    If any part is invalid, the remainder stays enforceable.
                  </li>
                  <li>
                    We may modify, terminate, or suspend services at any time.
                  </li>
                  <li>
                    You may terminate your account by request; you remain responsible for
                    prior activity.
                  </li>
                  <li>
                    We are not liable for failure to provide services due to events beyond
                    our control.
                  </li>
                  <li>
                    Governing law: Arab Republic of Egypt. Jurisdiction: Economic Courts of
                    Egypt.
                  </li>
                </ul>

                {/* SECTION 12 */}
                <h5 className="mt-5">12. Acknowledgment & Consent</h5>

                <p>
                  By using the Application, you acknowledge that you have read, understood,
                  and agree to this Privacy Policy and consent to our use, control,
                  processing, storage, and transfer of your Personal Data.
                </p>

                <p>
                  You represent that you have the right to share all information provided to
                  us and authorize us to use and share it under this Privacy Policy.
                </p>

                {/* SECTION 13 */}
                <h5 className="mt-5">13. Unsubscribing from Email Database</h5>

                <p>
                  We follow an opt-in and opt-out email subscription policy. To stop
                  receiving emails, click “unsubscribe” in any Yalla Fel Sekka email.
                </p>

                {/* SECTION 14 */}
                <h5 className="mt-5">14. How to Contact Us</h5>

                <p>If you have questions or want to update/remove your details contact us:</p>

                <p>
                  <strong>Phone:</strong> +201119409711
                  <br />
                  <strong>Email:</strong> customersupport@yallafelsekka.com
                  <br />
                  <strong>Address:</strong> Building 57 Street 250 – Degla Maadi, Cairo, Egypt
                </p>

              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicyComponent;
